import TransformationHeader from '../transformation-header/TransformationHeader';
import TransformationImageArea from '../transformation-image-area/TransformationImageArea';
import React from 'react';
import {ChangeLogs, ChangeLogsProps} from '../../screens/TransformationV2/components/ChangeLogs';

interface TransformationComponentProps {
    isEmbedded: boolean;
    cdnUrl: string;
    modifiedCdnUrl: string;
    isBgRemoved: boolean;
    isLoading: boolean;
    svgOrGif?: boolean;
    aspectRatio?: number;
    allowBgRemoval: boolean;
    handleCloseButton: () => void;
    saveImage: () => void;
    backgroundRemoveActions: () => void;
    onCropConfirm: (xPercent: number, yPercent: number, wPercent: number, hPercent: number) => void;
    onCropCancel: () => void;
    onRotate: (angle: number) => void;
    changeLogProps: ChangeLogsProps;
    rotation: number;
}

export default function TransformationComponent({
    isEmbedded,
    cdnUrl,
    modifiedCdnUrl,
    isBgRemoved,
    isLoading,
    svgOrGif,
    allowBgRemoval,
    handleCloseButton,
    saveImage,
    backgroundRemoveActions,
    onCropConfirm,
    aspectRatio,
    onCropCancel,
    changeLogProps,
    rotation,
    onRotate,
}: TransformationComponentProps) {
    return (
        <div className='flex w-full flex-col'>
            <TransformationHeader
                isEmbedded={isEmbedded}
                cdnUrl={cdnUrl}
                handleCloseButton={handleCloseButton}
                modifiedCdnUrl={modifiedCdnUrl}
                saveImage={saveImage}
            />
            <div className={'flex flex-grow overflow-y-auto'}>
                <div className={'flex-1 px-2'}>
                    <TransformationImageArea
                        aspectRatio={aspectRatio}
                        onCropCancel={onCropCancel}
                        allowBackgroundRemoval={allowBgRemoval}
                        cdnUrl={cdnUrl}
                        isBgRemoved={isBgRemoved}
                        isLoading={isLoading}
                        modifiedCdnUrl={modifiedCdnUrl}
                        svgOrGif={svgOrGif}
                        backgroundRemoveActions={backgroundRemoveActions}
                        onCropConfirm={onCropConfirm}
                        rotation={rotation}
                        onRotate={onRotate}
                    />
                </div>
                <div className={'hidden bg-[#293056] md:flex'}>
                    <ChangeLogs
                        originalFileType={changeLogProps.originalFileType}
                        originalFileSize={changeLogProps.originalFileSize}
                        newFileType={changeLogProps.newFileType}
                        cdnUrl={changeLogProps.cdnUrl}
                        bgRemoved={changeLogProps.bgRemoved}
                        bgReplaced={changeLogProps.bgReplaced}
                        cropped={changeLogProps.cropped}
                        dimensionsChanged={changeLogProps.dimensionsChanged}
                        greyToneApplied={changeLogProps.greyToneApplied}
                        loading={changeLogProps.loading}
                    />
                </div>
            </div>
        </div>
    );
}
